import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { PromotionsRoutingModule } from './promotions-routing.module';
import { PromotionsComponent } from './promotions.component';

import { FeaturesCommonModule } from 'src/app/features-common/features-common.module';
import { AgGridModule } from 'ag-grid-angular';
import { CarrierPromotionsComponent } from './carrier-promotions/carrier-promotions.component';
import { OccasionRewardsComponent } from './occasion-rewards/occasion-rewards.component';

import { LoyaltyRewardsConfigurationSmartComponent } from './loyalty-rewards/loyalty-rewards-configuration/loyalty-rewards-configuration-smart.component';
import { LoyaltyRewardsConfigurationComponent } from './loyalty-rewards/loyalty-rewards-configuration/loyalty-rewards-configuration.component';
import { ManagepromocodeComponent } from './manage-promocode/manage-promocode.component';
import { EditLoyaltyRewardsComponent } from './manage-promocode/edit-loyalty-rewards/edit-loyalty-rewards.component';
import { LoyaltyPromocodeSmartComponent } from './loyalty-rewards/loyalty-promocode-configuration/loyalty-promocode-configuration-smart.component';
import { LoyaltyPromocodeComponent } from './loyalty-rewards/loyalty-promocode-configuration/loyalty-promocode-configuration.component';
import { LoyaltyRewardsComponent } from './loyalty-rewards/loyalty-rewards.component';
import { PromoCodeHistoryComponent } from './manage-promocode/promo-code-history/promo-code-history.component';
import { ReceivedPromoComponent } from './manage-promocode/received-promo/received-promo.component';
import { FestivalPromotionsSmartComponent } from './occasion-rewards/festival-promotions/festival-promotions-smart.component';
import { FestivalPromotionsComponent } from './occasion-rewards/festival-promotions/festival-promotions.component';

import { EditPromotionsComponent } from './manage-promocode/edit-promotions/edit-promotions.component';
import { SendPromoComponent } from './manage-promocode/send-promo/send-promo.component';
import { SendPromoSmartComponent } from './manage-promocode/send-promo/send-promo-smart.component';
import { GeneratePromoSuccessComponent } from './promocode-actions/generate-promo-success/generate-promo-success.component';
import { AssignPromotionsComponent } from './carrier-promotions/assign-promotions/assign-promotions.component';
import { NewPromotionComponent } from './carrier-promotions/new-promotion/new-promotion.component';
import { NewPromotionSmartComponent } from './carrier-promotions/new-promotion/new-promotion-smart.component';
import { AssignPromotionsSmartComponent } from "./carrier-promotions/assign-promotions/assign-promotions-smart.component";
import { CreateFestivalComponent } from './occasion-rewards/create-festival/create-festival.component';
import { UpdateFestivalComponent } from './occasion-rewards/update-festival/update-festival.component';
import { BannerConfigurationComponent } from './banner-configuration/banner-configuration.component';
import { EditBannerComponent } from './banner-configuration/edit-banner/edit-banner.component';
import { ManageBannerComponent } from './banner-configuration/manage-banner/manage-banner.component';
import { RetailerBannerComponent } from './retailer-banner/retailer-banner.component';
import { AddBannerComponent } from './banner-configuration/add-banner/add-banner.component';
import { VideoConfigComponent } from './video-config/video-config.component';
import { AddpromotionComponent } from './video-config/addpromotion/addpromotion.component';
import { EditVideosComponent } from './video-config/edit-videos/edit-videos.component';
import { PromoCodeImportComponent } from './occasion-rewards/promo-code-import/promo-code-import.component'


//import { PromoCodeHistoryComponent } from './promo-code-history/promo-code-history.component';
@NgModule({
  declarations: [PromotionsComponent, 
    NewPromotionComponent, 
    CarrierPromotionsComponent, 
    EditPromotionsComponent, 
    OccasionRewardsComponent, 
    PromoCodeHistoryComponent, 
    ReceivedPromoComponent, 
    LoyaltyRewardsConfigurationComponent, 
    EditLoyaltyRewardsComponent, 
    LoyaltyPromocodeComponent, 
    LoyaltyRewardsConfigurationSmartComponent, 
    LoyaltyPromocodeSmartComponent, 
    ManagepromocodeComponent, 
    FestivalPromotionsComponent, 
    CreateFestivalComponent,
    UpdateFestivalComponent,
    FestivalPromotionsSmartComponent, LoyaltyRewardsComponent, SendPromoComponent, SendPromoSmartComponent, GeneratePromoSuccessComponent, NewPromotionSmartComponent, AssignPromotionsSmartComponent, AssignPromotionsComponent, NewPromotionComponent, CreateFestivalComponent, UpdateFestivalComponent, BannerConfigurationComponent, EditBannerComponent, ManageBannerComponent, RetailerBannerComponent, AddBannerComponent, VideoConfigComponent, AddpromotionComponent, EditVideosComponent, PromoCodeImportComponent,
    //  PromoCodeHistoryComponent

  ],
  imports: [
    FeaturesCommonModule,
    MatDatepickerModule,
    MatNativeDateModule, MatRippleModule,
    AgGridModule,
    PromotionsRoutingModule
  ],
  providers: [
  ]
})
export class PromotionsModule { }
